import Link from "next/link";
import type { FC } from "react";

import { AppLogo } from "@moment/design-system/AppLogo";

import { isDesktopAppMode } from "~/auth/interop/common";
import { CANVAS_NAME, HOMEPAGE_ROUTE } from "~/strings";
import { toTitleCase } from "~/utils/format/string";

export const AppHomeLink: FC = () => {
	return isDesktopAppMode() ? (
		<Link
			href={{ pathname: HOMEPAGE_ROUTE }}
			title={`All ${toTitleCase(CANVAS_NAME.PLURAL)}`}
			shallow
		>
			<AppLogo />
		</Link>
	) : (
		<Link href="https://moment.dev" title="Home">
			<AppLogo />
		</Link>
	);
};
